import Victor from "victor";
import { pxPerMetre } from "../settings";

export {default as getStateByCode} from "./getInitialState";
export {default as calcCollisionSpeeds} from "./calcCollisionSpeeds";
export const pxVictor = Victor(pxPerMetre, pxPerMetre);
